import cn from 'classnames';
import NavItem from 'components/nav-item';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import useScrollTracking from 'tracking/use-scroll-tracking';
import { CollectionType } from '../landing-page-slider-with-multiple-collections';
import styles from './slider-buttons.module.css';

interface Props {
  className?: string;
  collections: CollectionType[];
  currentCollection: CollectionType;
  trackingName?: string[];
  handleClicked: (collection: CollectionType) => void;
}

const SliderButtons: React.FC<Props> = ({
  className,
  collections,
  currentCollection,
  trackingName,
  handleClicked,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useScrollTracking(ref, trackingName);

  return (
    <div className={cn('relative mb-2', styles.scrollbarHide)}>
      <div
        className={cn(
          'flex snap-x snap-mandatory flex-row gap-3 p-1 lg:flex-wrap lg:overflow-hidden',
          className
        )}
        /** Remove grey area made by overflow-scroll */
        style={{
          overflow: 'auto',
          padding: 0,
          margin: 0,
          boxSizing: 'border-box',
        }}
        ref={ref}
      >
        {collections.map((collection, index) => (
          <NavItem
            className="whitespace-nowrap"
            selected={
              currentCollection.collectionHandle === collection.collectionHandle
            }
            onClick={() => handleClicked(collection)}
            key={index}
          >
            <FormattedMessage id={collection.title} />
          </NavItem>
        ))}
      </div>
    </div>
  );
};

export default SliderButtons;
